import { z } from "zod";
export const ForgeProjectAccessMode = z.enum(["InviteOnly", "Open", "Unlisted"]);
